import { render, staticRenderFns } from "./Administracao.vue?vue&type=template&id=b0e74d5e&"
import script from "./Administracao.vue?vue&type=script&lang=js&"
export * from "./Administracao.vue?vue&type=script&lang=js&"
import style0 from "./Administracao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports